import PropTypes from "prop-types";

const SvgIcon = ({ name, width, height, style = {} }) => {
  return (
    <object
      aria-label={`JSW ${name}`}
      width={width}
      height={height}
      type="image/svg+xml"
      data={`/assets/${name}.svg`}
      style={{ pointerEvents: "none", ...style }}
    />
  );
};

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export default SvgIcon;
